import { observable } from "mobx";
import { Exclude } from "class-transformer";
import { enumValue } from "../utils/enumerable";
import Enum from "./enum";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class VehicleResponse {
  /**
   * Vehicle registration plate.
   * @example
   * 1A13456
   */
  @observable
  licensePlate!: string;

  /**
   * Country ID.
   * @example
   * 389f9475-192f-476f-9d6e-62934311801b
   */
  @observable
  countryId!: string;
}

export default class Vehicle extends VehicleResponse {
  constructor(licensePlate?: string, countryId?: string) {
    super();
    if (licensePlate) {
      this.licensePlate = licensePlate;
    }

    if (countryId) {
      this.countryId = countryId;
    }
  }

  @Exclude()
  @enumValue("countries", "countryId")
  country?: Enum;
}
